<template>
    <div>
        <div v-if="this.isLoading" class="div-loading color-pink">
            <h2>Loading</h2>
            <div><span class="icon"><img src="/Assets/img/spin.svg" /></span></div>
        </div>
        <div id="articles-wrapper" v-if="this.articles && this.articles.length > 0">
            <ArticleBox v-for="(article, index) in this.articles"
                        v-bind:item="article"
                        v-bind:index="index"
                        v-bind:key="article.articleId"
                        :article="article" />
        </div>
        <div class="load-more-container" v-if="this.showMoreButton">
            <button v-if="this.isLoadingMore === true">
                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
            </button>
        </div>
    </div>
</template>

<script>
    import ArticleBox from '@/components/ArticleBox.vue'
    import api from '@/api'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import settings from '@/settings'
    import util from '@/helpers/util'


    export default {
        components: {
            ArticleBox
        },
        props: ['excludeArticles'],
        data() {
            return {
                isLoading: false,
                isLoadingMore: false,
                isGiftList: false,
                articles: null,
                perPage: 10,
                pageNumber: 1,
                showMoreButton: false,
                autoLoadMoreEnabled: false
            }
        },
        created() {
            window.addEventListener('scroll', this.autoLoadMore);
        },
        destroyed() {
            window.removeEventListener('scroll', this.autoLoadMore);
        },
        mounted() {
            this.init();
        },
        computed: {
            finalExcludeArticle: function () {
                return (this.excludeArticles ? this.excludeArticles : 0);
            }
        },
        methods: {
            init() {
                this.isLoading = true;
                this.isLoadingMore = false;
                this.isGiftList = false;
                this.articles = [];

                console.log('this.$route.name', this.$route.name);

                if (this.$route.name == 'giftideas' || this.$route.name == 'giftlist' || this.$route.name == 'giftlist2') {
                    this.isGiftList = true;
                }

                this.loadData().then(() => {
                    this.isLoading = false;
                });


            },
            autoLoadMore() {
                if (this.autoLoadMoreEnabled) {
                    var loadMoreElem = document.querySelector('.load-more-container');
                    if (loadMoreElem && util.checkVisible(loadMoreElem)) {
                        this.loadMoreData();
                    }
                }
            },
            loadMoreData() {

                ga.event('click', { 'event_category': 'articlepages', 'event_label': this.pageNumber });
                clicky.log('Articles - Load More Data Page #' + this.pageNumber, 'click')
                this.autoLoadMoreEnabled = false;
                this.isLoadingMore = true;
                this.loadData().then(() => {
                    this.isLoadingMore = false;
                });
            },
            loadData() {

                return api.getArticles(this.perPage, this.pageNumber, this.finalExcludeArticle, this.isGiftList).then((response) => {
                    console.log('response', response);

                    if (response.data) {
                        if (response.data.length < this.perPage)
                            this.showMoreButton = false;
                        else
                            this.showMoreButton = true;

                        var tmp = response.data;
                        tmp.forEach(a => {
                            a.imgUrl = 'https://' + settings.siteUrl + a.imgUrl;
                        });


                        this.articles.push(...tmp);
                        this.pageNumber = this.pageNumber + 1;

                        setTimeout(() => { this.autoLoadMoreEnabled = true; }, 500);

                    }

                });
            }

        }

    }
</script>
